// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";

import CheckmarkIcon from "../../icons/checkmark.svg";

type Props = {
  class?:     string,
  disabled?:  boolean,
  onChange?:  Function,
  label?:     string,
  name?:      string,
  required?:  boolean,
};

export default class Checkbox extends PureComponent {
  props: Props;

  handleClick = () => this.checkbox.click();

  render({ children, dirty, errors, eventListenerType, label, required, subject, submitted, title, value, ...props }: Props, state: any, { t }: Context) {
    const displayErrors = Boolean(submitted && errors && errors.length);

    return (
      <div
          title={title}
          class={classNames(
            this.props["class"],
            styles.block
          )}>

        <div class={styles.row}>
          <input
              {...props}
              id={props.name}
              checked={value}
              type="checkbox"
              ref={input => this.checkbox = input}
              class={styles.input}
              tabindex="-1"
          />

          <button
              type="button"
              disabled={props.readOnly || props.disabled}
              onClick={this.handleClick}
              class={classNames(
                "button",
                styles.button
              )}>

            <CheckmarkIcon
                class={styles.icon}
            />
          </button>

          <label
              for={props.name}
              class={classNames(
                styles.label,
                { [styles.required]    : required,
                  [styles.interaction] : children.length === 0,
                  [styles.disabled]    : props.readOnly || props.disabled }
              )}>

            {children.length > 0 ? children : label}
          </label>
        </div>
      </div>
    );
  }
}
